//this is counter widget
import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import DeviceNames from './DeviceNames';
import DeviceValues from './DeviceValues';
import DeviceStatuses from './DeviceStatuses';
import { getDeviceStatusText } from '../utils';
import dayjs from 'dayjs';

const PaymentWarning = () => {
  return (
    <div className="flex items-start gap-x-2 p-3 my-2 rounded-2xl bg-orange-50">
      <WarningAmberRoundedIcon className="text-red-500" />
      <div>
        <p className="font-semibold text-gray-800">Устройство заблокировано</p>
        <p className="text-sm text-gray-600">Требуется оплата</p>
      </div>
    </div>
  );
};

const DeviceCard = ({ device }) => {
  const tableData = [
    { title: 'Устройство', value: device?.type?.name },
    { title: 'Текущее показание', value: device?.type?.key !== 'controller' && <DeviceValues device={device} /> },
    { title: 'Серийный номер', value: device?.serial_number },
    { title: 'Версия прошивки', value: device?.device_version },
    { title: 'Токен', value: device?.type?.key === 'controller' && device?.unique_id },
    { title: 'Тип выхода', value: device?.output },
    { title: 'Последний выход на связь', value: device?.last_event?.at && getDeviceStatusText(device?.last_event?.at) },
    { title: 'Дата поверки', value: device?.verification_date && dayjs(device?.verification_date).format('DD.MM.YYYY') },
    { title: 'Производитель', value: device?.manufacturer },
  ];

  return (
    <>
      <DeviceNames device={device} style="line-clamp-1 text-lg font-bold text-center" />

      <div className="flex items-center justify-center my-2">
        <DeviceStatuses device={device} style="bg-orange-50 font-bold text-gray-800 me-2 px-2.5 py-0.5 rounded-full line-clamp-1" />
      </div>
      {device?.payment_required && <PaymentWarning />}
      <table className="table-auto w-full text-base my-4">
        <tbody>
          {tableData.map(({ title, value }) => {
            return value ? (
              <tr key={title}>
                <td className="text-start border-y">
                  <p className="line-clamp-1">{title}</p>
                </td>
                <td className="text-start border-y">
                  <div className="ml-4">{value || '-'}</div>
                </td>
              </tr>
            ) : null;
          })}
        </tbody>
      </table>
    </>
  );
};

export default DeviceCard;
